export default "__VITE_ASSET__DqO3U0tw__"